import React from 'react';
import { useReveal } from '../lib/useReveal';
export function GuaranteeSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5 relative overflow-hidden" data-id="element-155">
      <div className="container mx-auto max-w-3xl relative z-10" data-id="element-156">
        <div ref={ref1} className={`reveal bg-[#111111] rounded-3xl p-8 md:p-12 border border-[#eab308]/20 shadow-[0_0_40px_rgba(234,179,8,0.1)] text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-157">
          <div className="w-20 h-20 bg-gradient-to-br from-[#eab308] to-[#d4a017] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-158">
            <span className="text-4xl" data-id="element-159">🛡️</span>
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-160">
            Garantía de 7 días sin preguntas
          </h2>

          <div className="space-y-4 text-gray-300 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-161">
            <p data-id="element-162">Accedés al sistema completo. Lo explorás. Lo practicás.</p>
            <p data-id="element-163">
              Y si en los primeros 7 días sentís que no es lo que esperabas — te
              devolvemos el dinero completo.
            </p>
            <p className="text-white font-medium" data-id="element-164">
              Sin preguntas. Sin burocracia. Sin demoras.
            </p>
            <p className="text-[#eab308] font-bold text-xl mt-6" data-id="element-165">
              El riesgo es cero. La transformación puede ser total.
            </p>
          </div>
        </div>
      </div>
    </section>;
}